import React, { useCallback } from 'react'
import { StatsContainerProps } from './StatsContainer.types'
import { StatCard } from '../../atoms/StatCard'
import { Container } from './StatsContainer.styles'

export const StatsContainer: React.FC<StatsContainerProps> = ({
  stats,
  fullWidth = false,
  className,
  style,
  onStatClick,
}) => {
  const handleStatClick = useCallback(
    (stat: (typeof stats)[0]) => {
      if (onStatClick) {
        onStatClick(stat.id, stat)
      }
    },
    [onStatClick]
  )

  return (
    <Container $fullWidth={fullWidth} className={className} style={style}>
      {stats.map(({ id, ...statProps }) => (
        <StatCard
          key={id}
          {...statProps}
          clickable={!!onStatClick}
          onClick={() => handleStatClick({ id, ...statProps })}
        />
      ))}
    </Container>
  )
}

StatsContainer.displayName = 'StatsContainer'
